export default class HistoryStatementCtrl {
  constructor ($scope, $mdDialog, PortfolioSrv, PortfolioModalSrv, GlobalConfig) {
  // constants
    var historyVm = this
    const sharedVariable = PortfolioModalSrv.getVariable()
    historyVm.statements = sharedVariable.statements
    const cssClass = {
      arrowUp   : "mdi-hardware-keyboard-arrow-up",
      arrowDown : "mdi-hardware-keyboard-arrow-down"
    }
    historyVm.showDescription = cssClass.arrowDown

  // methods
    historyVm.close         = close
    historyVm.showStatement = showStatement

    activate()
    function activate() {
      for (var i = historyVm.statements.length - 1; i >= 0; i--) {
        historyVm.statements[i].isHidden = true
      }
    }  

    function close () {
      return $mdDialog.hide()
    }  

    function showStatement(statement){
      if(statement.isHidden){
        historyVm.showDescription = cssClass.arrowUp
      } else {
        historyVm.showDescription = cssClass.arrowDown
      }
      statement.isHidden = !statement.isHidden
    }

  }
}

HistoryStatementCtrl.$inject = ['$scope', '$mdDialog', 'PortfolioSrv', 'PortfolioModalSrv', 'GlobalConfig']



// WEBPACK FOOTER //
// ./src/app/u-faculty/portfolio/myPortfolio/modals/historyStatementCtrl.js